module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr11-b50ad13c2dded97be4dcbbc199664239.jpg";